import axios from "axios";
import shortid from "shortid";
//import { createBrowserHistory } from 'history';

import WP from "WP";
//import { parseQueryString } from 'helpers';

import PostFetcher from "./PostFetcher";
import { store } from "store";

//const history = createBrowserHistory();

if (window.location.hostname !== "localhost") {
  //axios.defaults.headers.common['X-WP-Nonce'] = WP.nonce;
}

const enableDebugLogging = localStorage.getItem("enableDebugger") === "true";

const api = !WP
  ? {}
  : {
      getMenuByLocation: (location) => {
        const storeState = store.getState();

        if (storeState.menus[WP.lang][location]) {
          return Promise.resolve({ data: Object.values(storeState.menus[WP.lang][location]) });
        }

        return axios
          .get(WP.api_base + "wp-api-menus/v2/menus/" + WP[location + "_id"], {
            params: {
              stamp: shortid.generate(),
            },
          })
          .then((resp) => {
            store.dispatch({ type: "ADD_MENU_TO_STORE", payload: { location, menu: resp.data } });
            return resp;
          });
      },

      pageFetcher: new PostFetcher({
        storeKey: "pages",
        fetchEndpoint: WP.api_base + "wp/v2/pages",
        revisionsFrom: "pages",
        debug: enableDebugLogging,
      }),

      postFetcher: new PostFetcher({
        storeKey: "posts",
        fetchEndpoint: WP.api_base + "wp/v2/posts",
        revisionsFrom: "posts",
        debug: enableDebugLogging,
      }),

      accommodationFetcher: new PostFetcher({
        storeKey: "accommodation",
        fetchEndpoint: WP.api_base + "wp/v2/accommodation",
        debug: enableDebugLogging,
      }),

      adventureFetcher: new PostFetcher({
        storeKey: "adventures",
        fetchEndpoint: WP.api_base + "wp/v2/adventures",
        debug: enableDebugLogging,
      }),

      diningFetcher: new PostFetcher({
        storeKey: "dining",
        fetchEndpoint: WP.api_base + "wp/v2/dining",
        debug: enableDebugLogging,
      }),

      eventFetcher: new PostFetcher({
        storeKey: "events",
        fetchEndpoint: WP.api_base + "wp/v2/events",
        debug: enableDebugLogging,
      }),

      rentalProductsFetcher: new PostFetcher({
        storeKey: "rentals",
        fetchEndpoint: WP.api_base + "wp/v2/rentals",
        debug: true,
      }),

      rentalTypesTermFetcher: new PostFetcher({
        storeKey: "rental_types",
        fetchEndpoint: WP.api_base + "wp/v2/rental_types",
        debug: enableDebugLogging,
      }),

      conferenceVenuesFetcher: new PostFetcher({
        storeKey: "conference_venues",
        fetchEndpoint: WP.api_base + "wp/v2/conference_venues",
        debug: enableDebugLogging,
      }),

      search: (query) => {
        return axios.get(WP.api_base + WP.theme_name + "/v2/search", {
          params: {
            lang: WP.lang,
            query: query,
            stamp: shortid.generate(),
          },
        });
      },

      registerBrokenLink: ({ path, from }) => {
        return axios.get(WP.api_base + WP.theme_name + "/v2/register-broken-link", {
          params: {
            lang: WP.lang,
            path: path,
            from: from,
            stamp: shortid.generate(),
          },
        });
      },

      sendEventBookingEmail: (data) => {
        return axios.post(WP.api_base + WP.theme_name + "/v2/send-event-booking-email", data);
      },

      sendSnowmobileRentalRequest: (data) => {
        return axios.post(WP.api_base + WP.theme_name + "/v2/kb-send-snowmobile-rental-request-email", data);
      },

      sendSnowmobileRentalOrderConfirmation: (data) => {
        return axios.post(WP.api_base + WP.theme_name + "/v2/kb-send-snowmobile-rental-confirmation-email", data);
      },

      sendSkiPackageRentalRequest: (data) => {
        return axios.post(WP.api_base + WP.theme_name + "/v2/kb-send-ski-package-rental-request-email", data);
      },

      sendSkiPackageRentalOrderConfirmation: (data) => {
        return axios.post(WP.api_base + WP.theme_name + "/v2/kb-send-ski-package-rental-confirmation-email", data);
      },

      sendEquipmentRentalRequest: (data) => {
        return axios.post(WP.api_base + WP.theme_name + "/v2/kb-send-equipment-rental-request-email", data);
      },

      sendEquipmentRentalOrderConfirmation: (data) => {
        return axios.post(WP.api_base + WP.theme_name + "/v2/kb-send-equipment-rental-confirmation-email", data);
      },

      sendConferenceEnquiry: (data) => {
        return axios.post(WP.api_base + WP.theme_name + "/v2/kb-send-conference-venue-enquiry-email", data);
      },
    };

export default api;
